import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import React from "react";

interface TruncateProps {
  text: string;
  maxLength?: number;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  sideOffset?: number;
  alignOffset?: number;
}

export const HoverRevealText: React.FC<TruncateProps> = ({
  text,
  maxLength = 25,
  side = "top",
  align = "center",
  sideOffset = 4,
  alignOffset = 0,
}) => {
  if (!text) return <p className="text-xs">NA</p>;
  const isTruncated = text?.length > maxLength;
  const displayText = isTruncated ? text.slice(0, maxLength) + "..." : text;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-pointer">{displayText}</span>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        align={align}
        sideOffset={sideOffset}
        alignOffset={alignOffset}
        className="max-w-xs whitespace-pre-wrap break-words text-xs p-2"
      >
        {text}
      </TooltipContent>
    </Tooltip>
  );
};